import EventImage from '#assets/svg/Onboard-Probadge.svg';
import { BoxIcon } from '#atoms';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';

const Event = () => {
  const navigate = useNavigate();

  return (
    <div className="relative flex items-center justify-center w-full pb-82">
      <div className="bg-gradient-to-b from-[#00FFC399] to-[#12111480] flex-col p-20 w-full max-w-939 h-full flex justify-center items-center to-[550px]">
        <button className="ml-auto" onClick={() => navigate('/home')}>
          <BoxIcon width={18} height={18} type="x-white" onlyIcon />
        </button>
        <img className="w-full py-40 max-w-450" src={EventImage} />
        <Link
          to={'https://walla.my/v/elknFURvG2XebeaJQF44'}
          target="_blank"
          className="text-[#8E899F] underline text-[14px]"
        >
          피벗 트레이닝 전문가 신청하기
        </Link>
        <button
          onClick={() => navigate('/trainer-community/write?tag=CONCERN')}
          className="fixed bottom-0 left-1/2 -translate-x-1/2 py-16 rounded-8 bg-[#089B7A] text-[#EAE8ED] w-[calc(100%-40px)] text-center max-w-939 mb-20"
        >
          고민 작성하고 해결하기
        </button>
      </div>
    </div>
  );
};

export default Event;
